/**
 * @ignore
 * User: daletan
 * Date: 1/15/16
 * Time: 5:56 PM
 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
 */

'use strict';

const contactDealerLauncher = require('../../contact/dealer/helpers/contactDealerLauncher');
const netPriceLauncher = require('../../contact/netPrice/helpers/netPriceLauncher');
const PurchaseTracking = require('../../global/mixins/purchaseTracking');

const launchContactDealer = (actionContext, payload) => {
    const {
        itemPk,
        dealerPk,
        currentStep,
        handleCtaClick,
        tracking: linkLocation,
        modalContentData,
        isRequestMoreImages,
        isVerifiedTrade,
    } = payload;

    contactDealerLauncher({
        context: actionContext,
        itemPk,
        linkLocation,
        dealerPk,
        currentStep,
        handleCtaClick,
        modalContentData,
        isRequestMoreImages,
        isVerifiedTrade,
    });
};

const trackNetPriceClick = purchaseTracking => {
    if (purchaseTracking) {
        purchaseTracking.trackNetPriceEvent({
            actionSuffix: 'clicked-amppage',
        });
    }
};

const launchRequestNetPrice = (actionContext, payload) => {
    const { item, itemPk, currency, tracking: linkLocation } = payload;
    const purchaseTracking = new PurchaseTracking({ item, pageContext: linkLocation.pageContext });
    trackNetPriceClick(purchaseTracking);
    netPriceLauncher({
        context: actionContext,
        itemPk,
        purchaseTracking: purchaseTracking,
        linkLocation,
        item,
        currency,
    });
};

// need to keep this variable reference
// otherwise Fluxible context will see `this` this as undefined
const modals = (module.exports = {
    contactDealer(actionContext, payload, done) {
        // FINDING-7331 This method is for an optimizely variant to make the contact dealer modal
        //              appear from clicking on a cta in the sidebar. Remove this code if the
        //              variant is removed. Alternatively, remove this comment if the variant
        //              becomes permanent.
        // calling "private" property so can be spied on in tests
        modals._dealer(actionContext, payload);
        done();
    },
    netPrice(actionContext, payload, done) {
        modals._netPrice(actionContext, payload);
        done();
    },
    _dealer: launchContactDealer,
    _netPrice: launchRequestNetPrice,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/modals.es.js